import React from 'react'
import { Form, DatePicker } from 'antd'
import styled from 'styled-components'
import { t } from '@/i18n'
import { disabledDate, disabledDateTime } from '@/utils/appointment'

const ExecutionTimeSelector: React.FC = () => (
  <Wrapper>
    <Form.Item
      label={<span style={{ color: '#666' }}>{t('执行时间')}</span>}
      name="taskTime"
      rules={[{ required: true, message: t('请选择执行时间') }]}
      required
    >
      <DatePicker
        showTime
        placeholder={t('请选择日期与时间')}
        style={{ width: '240px' }}
        format="YYYY-MM-DD HH:mm:ss"
        disabledDate={disabledDate}
        disabledTime={disabledDateTime}
      />
    </Form.Item>
  </Wrapper>
)

export default ExecutionTimeSelector

const Wrapper = styled.div`
  margin-left: 115px;
`
